module.exports = __webpack_public_path__ + "img/nc.d393b8fa.svg";